import { Injectable } from '@angular/core';
import { ConsentForm } from '../model/consentForm.model';
import { environment } from '../../environments/environment';
import { RequestService } from "../services/request.service";

@Injectable()
export class ConsentFormService {


  constructor(
    private requestService: RequestService
  ) {}

  submitForm(data: ConsentForm) {
      return this.requestService.Post(environment.baseUrl + "/ConsentFormOnline/Submit", data);
  }
  GetCompany(CompanyID: string,StoreNo: string, Type: string){
      const param = {
        "CompanyID": CompanyID,
        "StoreNo": StoreNo,
        "Type": Type
      };
      return this.requestService.Post(environment.baseUrl + "/ConsentFormOnline/GetCompany", param);
  }
  verifyRecaptcha(recaptchaToken: string) {
        const baseUrl = environment.baseUrl;
        const body = { recaptchaToken: recaptchaToken };
        return this.requestService.Post(baseUrl + '/ConsentFormOnline/VerifyRecaptcha',body);
  };
}